export default function Testimonial() {
    return (
        <>
        <div class="TImage-T"></div>
         <section class="Testimonial">
            <img src={require("../../Testimonial.jpg")} alt="Testimonial" class="TImage" />
            <div>
                <h1>Student's words:</h1>
                <p>   “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod.”</p>
                <p>---- John Doe</p>
            </div>
        </section>
        </>
    )
}